<template>
  <div>
    <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" :style=" NavSolid ? { height: '5rem' } : {}"></div>
     
    <!-- Blog Header with rotating images -->
    <div v-if="detailInfo.length > 0" class="blog-header-container">
      <!-- Blog Carousel Full Width -->
      <div class="blog-carousel-container">
        <transition name="slide" mode="out-in">
          <div :key="currentBlogIndex" class="blog-carousel-slide">
            <div
              class="blog-carousel-image"
              :style="'background-image: url(' + currentBlogImage + ')'"
            ></div>
            <div class="blog-carousel-content">
              <div class="d-flex">
                <div class="d-block">
                  <h2 class="blog-carousel-title">{{truncateTitle( currentBlogMostrado?.tittle) }}</h2>
                  <p class="blog-carousel-description text-light">
                    {{ truncateDescription(currentBlogMostrado?.detail) }}
                  </p>
                </div>
                <div class="ml-auto mt-auto">
                  <router-link
                    :to="currentBlog.ruta || '/blog'"
                    class="btn btn-pill btn-primary-solid blog-btn-more zoom"
                  >
                    {{ $t('common.seeMore') }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>

    <!-- Fallback to static header when no blog images -->
    <div v-else class="">
      <!-- <HeaderView
        :imgHeader="infoHeader.img"
        :dataHeader="infoHeader.TextHeader"
      ></HeaderView> -->
    </div>

    <div class="bg-light py-5 px-2 mb-5" :class="detailInfo.length === 0 ? 'py-5 my-5' : 'py-5 my-0'">
      <h1 class="h2 text-primary text-center">{{ $t('blog.heading') }}</h1>
      <p class="text-secondary text-center">
        {{ $t('blog.subtitle') }}
      </p>
      <alertComponent
        v-if="detailInfo.length == 0 && !loadingData && dataLoaded"

        iconColor="primary"
        :variant="1"
        :icon="true"
        iconClass="fa-solid fa-newspaper"
        :title="$t('blog.unavailableTitle')"
        :description="$t('blog.unavailableDesc')"
      ></alertComponent>
      <div class="px-md-5" v-else>
        <carouseCardBlogGeneral
          class=""
          :detail="detailInfoMostrado"
        ></carouseCardBlogGeneral>
      </div>
      <!-- <div v-if="detailInfo" class="mt-5 pt-5">
          
          <h2 class="text-secondary text-center">
            <span style="font-weight: 900 !important"> Último </span>
            <span style="font-weight: lighter !important"> blog </span>
          </h2>
          <p class="text-secondary text-center">Descubra las mejores actividades, restaurantes, teatros, vida nocturna y más.</p>
          <carouseCardBlogLast class="mt-5" :detail="detailInfo"></carouseCardBlogLast>
        </div> -->
    </div>

    <!-- <div v-for="item of destacados" :key="item.id" class="container-fluid bg-gray pb-2">
      <div class="row pb-4">
        <div class="col-md-4  mt-5 p-md-5 pl-md-0 pl-md-0 ml-2 offset-md-1 movil" >
          <img class="img-fluid" style="box-shadow: -15px -15px grey; border-radius:15px;" :src="item.img" alt="">
        </div>
        
        <div class="col-md-7 py-5 pl-md-5 pl=4 mt-md-5">
          <div class="btn mx-md-3 mb-3 btn-primary" style=" box-shadow:none !important;">Articulo destacado</div>
          <div class="ml-md-3">
            <h1 class=" text-left full">{{ item.titulo }}</h1>
            <h2 class=" text-left movil">{{ item.titulo }}</h2>
            <span v-html="item.descripcion" class="" />
            <p class="mb-3">{{ $moment(item.fecha).utc().format('DD/MM/YYYY') }}</p>
            <button @click="$router.push('/post_blog/'+item.id)" class="btn btn-outline-primary"> {{ item.textoboton }} </button>
          </div>
        </div>
        
        <div class="col-md-5  mt-5 p-5 full" >
          <img class="img-fluid" style="box-shadow: -15px -15px grey; border-radius:15px; height:375px; width:501px" :src="item.img" alt="">
        </div>
      </div>
    </div>
  
    <div class="container-fluid p-0 " :style="'height:100%;background-image: url('+ con.blog_banner1_img +');background-color: #cccccc;height: 450px;background-position:center;background-repeat: no-repeat;background-size: cover; position: relative;'" >
      <div class="movil" style="padding:10%;">
            <h2 class="text-light text-center">{{ con.blog_banner1_texto }}</h2>
        </div>
        <div class="full" style="padding:10%;">
            <h1 class="text-light "> {{con.blog_banner1_texto}} </h1>
        </div>
      </div>
    
    <div class="container-fluid my-5 px-md-5 contenedor3">    
        <b-card-group deck class="contenido3">
            <CardBlog v-for="it in articulos" 
            class="mb-5"
            :key="it.id"
            :product="it" />
        </b-card-group>
    </div> -->
  </div>
</template>

<script>
import AOS from 'aos'
import carouseCardBlogLast from "../components/carouseCardBlogLast.vue";
import carouseCardBlogGeneral from "../components/carouseCardBlogGeneral.vue";
import HeaderView from "../components/HeaderView.vue";
import alertComponent from "../components/alertComponent.vue";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";
import { buildBlogPath } from "@/utils/blogUrl";
import { tField } from "@/i18n";

export default {
  props: ["NavSolid"],
  components: {
    HeaderView,
    carouseCardBlogGeneral,
    carouseCardBlogLast,
    alertComponent,
  },
  data() {
    return {
      // Items crudos del backend (se re-evalúan al cambiar locale via computed)
      blogItemsRaw: [],
      loadingData: false,
      dataLoaded: false,
      infoHeader: {
        img: "https://img.freepik.com/fotos-premium/paredes-pisos-naranjas-sala-estar_1086760-36225.jpg?w=826",
        TextHeader: "",
      },
      table: "blog",

      articulos: [],
      destacados: [],
      // con:{blog_banner1_texto:'',blog_banner1_img:''}

      // Blog header carousel
      currentBlogIndex: 0,
      blogCarouselInterval: null,
    };
  },
  computed: {
    // Locale reactivo para tField
    currentLocale() {
      return this.$i18n.locale;
    },
    // Lista derivada: mapea los items crudos a la forma con
    // tittle/detail ya resueltos segun el idioma activo.
    // Se re-evalúa cuando cambia i18n.locale.
    detailInfo() {
      return this.blogItemsRaw;
    },
    detailInfoMostrado() {
      const locale = this.currentLocale;
      return (this.blogItemsRaw || []).map((it) => ({
        id: it.Id,
        tittle: tField(it, "Titulo", locale),
        detail: tField(it, "Descripcion", locale),
        textoboton: this.$t("common.seeMore"),
        img: it.ImgUrl,
        date: this.$moment(it.Fecha).format("DD-MM-YYYY"),
        // Pasa el locale activo para que los links respeten /es/ o /en/
        // segun corresponda. Antes generaba siempre /blog/:id/:slug
        // sin prefix y el redirect legacy forzaba a /es/.
        ruta: buildBlogPath(it, locale),
      }));
    },
    // Item activo del header carousel, ya con tittle/detail resueltos
    currentBlogMostrado() {
      return this.detailInfoMostrado[this.currentBlogIndex] || {};
    },
    currentBlog() {
      return this.detailInfo[this.currentBlogIndex] || {};
    },
    currentBlogImage() {
      return this.detailInfo[this.currentBlogIndex]?.img || this.infoHeader.img;
    },
  },
  async mounted() {
    console.log("mounted blog--------------");
    this.loadingData = true;
    this.$isLoading(true);
    this.infoHeader.TextHeader = this.$t('blog.heading');
    await this.obtenerArticulos();
    this.startBlogHeaderCarousel();
    this.$isLoading(false);
    this.loadingData = false;
    console.log("mounted blog finish", this.detailInfo);
  },
  updated() {
    AOS.refresh()
  },
  beforeDestroy() {
    this.stopBlogHeaderCarousel();
  },
  methods: {
    startBlogHeaderCarousel() {
      if (this.detailInfo.length <= 1) return;

      this.stopBlogHeaderCarousel(); // Asegurarse de que no haya intervalos previos

      this.blogCarouselInterval = setInterval(() => {
        this.nextBlogImage();
      }, 3000); // Cambiar cada 3 segundos
    },

    stopBlogHeaderCarousel() {
      if (this.blogCarouselInterval) {
        clearInterval(this.blogCarouselInterval);
        this.blogCarouselInterval = null;
      }
    },

    nextBlogImage() {
      if (this.detailInfo.length === 0) return;
      this.currentBlogIndex =
        (this.currentBlogIndex + 1) % this.detailInfo.length;
    },

    nextBlog() {
      this.nextBlogImage();
      this.resetCarouselTimer();
    },

    prevBlog() {
      if (this.detailInfo.length === 0) return;
      this.currentBlogIndex =
        (this.currentBlogIndex - 1 + this.detailInfo.length) %
        this.detailInfo.length;
      this.resetCarouselTimer();
    },

    truncateDescription(text) {
      if (!text) return "";
      const strippedText = text.replace(/<[^>]*>/g, "");
      if (strippedText.length > 40) {
        return strippedText.substring(0, 40) + "...";
      }
      return strippedText;
    },
    truncateTitle(text) {
      if (!text) return "";
      const strippedText = text.replace(/<[^>]*>/g, "");
      if (strippedText.length > 40) {
        return strippedText.substring(0, 40) + "...";
      }
      return strippedText;
    },

    resetCarouselTimer() {
      this.startBlogHeaderCarousel();
    },

    // Métodos existentes...
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    async obtenerArticulos() {
      try {
        const resolvedDomain = this.resolvePublicDomain();
        let res = await this.$store.dispatch("get", {
          path: `Blog/public/getAll?domain=${encodeURIComponent(resolvedDomain)}`,
        });
        console.log("API Response:", res);
        
        if (res && Array.isArray(res) && res.length > 0) {
          console.log("obtenerArticulos", res);
          // Guardamos los items crudos del backend. La proyeccion a
          // { tittle, detail, ... } se hace en el computed
          // `detailInfoMostrado`, que es reactivo a i18n.locale.
          for await (let it of res) {
            this.blogItemsRaw.push(it);
          }
        } else {
          console.log("No articles found or invalid response");
          this.destacados = [];
          this.articulos = [];
        }
        this.dataLoaded = true;
        // for await (let it of articulos) {
        //   let dataA = {
        //     id: it.id,
        //     titulo: it.Titulo,
        //     descripcion: it.Descripcion,
        //     textoboton: "Ver más",
        //     img: it.ImgUrl,
        //     fecha: it.fecha,
        //     ruta: "/post_blog/" + it.Id,
        //   };
        //   this.articulos.push(dataA);
        // }
      } catch (error) {
        console.log("err", error);
        this.destacados = [];
        this.articulos = [];
        this.dataLoaded = true;
        this.$swal({
          icon: "error",
          title: "Oopss!",
          text: "Error: " + error,
        });
      }
    },
  },
};
</script>
<style scoped>
.bg-img-hotel {
  background-image: url("../assets/NAO/2-home/blog4.png");
  background-color: #cccccc;
  height: 450px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}
.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;
  scroll-snap-type: mandatory;
  scroll-behavior: smooth;
  word-wrap: break-word !important;
  margin-bottom: 50px;
}
.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;
  /* white-space: nowrap; */
}
/* Slider X (different sized images) */
.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}
.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}
.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}
.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}
.searchdiv {
  /* background-color:#fd306e !important; */
  /* background-color: black !important; */
  /* padding: 30px;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.25);
  border-radius: 20px; */
}
 
.carousel-item img {
  /* height:100vh!important ; */
}
@media only screen and (max-width: 600px) {
}

.blog-carousel-container {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  background-color: 
color-mix(in srgb, var(--primary) 30%, transparent) !important
}

.blog-carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.blog-carousel-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  filter: brightness(0.8);
  }
.blog-carousel-image::before {
  content: "";
  position: absolute;
  inset: 0;
  
  width: 100%;
  height: 100%;
  background: var(--primary-dark);
  filter: none;

  z-index: -1;
  opacity: 0.4;
}
 

.blog-carousel-content {
  position: absolute;
  bottom: 40px;
  left: 40px;
  right: 40px;
  color: white;
  text-align: left;
}

.blog-carousel-title {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.blog-carousel-description {
  font-size: 1.1rem;
  margin-bottom: 15px;
  max-width: 600px;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

.blog-btn-more {
  padding: 10px 30px;
  border-radius: 50px;
  font-weight: 600;
}

/* Transición slide */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}

.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}

.slide-enter-to {
  transform: translateX(0);
  opacity: 1;
}

.slide-leave {
  transform: translateX(0);
  opacity: 1;
  position: absolute;
}

.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
  position: absolute;
}

@media (max-width: 768px) {
  .blog-carousel-container {
    height: 300px;
  }

  .blog-carousel-content {
    bottom: 20px;
    left: 20px;
    right: 20px;
  }

  .blog-carousel-title {
    font-size: 1.5rem;
  }

  .blog-carousel-description {
    font-size: 0.9rem;
  }

  .blog-carousel-controls {
    bottom: 20px;
    right: 20px;
  }
}

@media (max-width: 576px) {
  .blog-carousel-content .d-flex {
    display: block !important;
  }

  .blog-carousel-content .ml-auto {
    margin-left: 0 !important;
    margin-top: 15px;
  }

  .blog-carousel-content .mt-auto {
    margin-top: 15px;
  }
}
</style>
